import PropTypes from 'prop-types';
import cn from 'classnames';

import DesktopTabButtons from './DesktopTabButtons.jsx';
import MobileTabButtons from './MobileTabButtons.jsx';
import { useLayoutEffect, useState } from 'react';

export default function LdsTabs({
  id,
  className = '',
  activeTab,
  ariaLabel,
  tabAlign = 'align-left',
  tabStyle = 'card',
  onChange,
  tabLabels = [],
  children,
  ...rest
}) {
  const [forceMobile, setForceMobile] = useState(false);

  // If tab labels are too long for one row in desktop, render the mobile version
  useLayoutEffect(() => {
    function checkWindowSize() {
      const tabs = document.querySelectorAll('.tab-btn-container .tab-btn');
      const tabContainerWidth = tabs[0].closest('.tab-btn-container').offsetWidth;
      let totalTabWidth = 0;
      tabs.forEach((tab) => { totalTabWidth += tab.offsetWidth; });
      if (totalTabWidth > tabContainerWidth) setForceMobile(true);
      else setForceMobile(false);
    }
    checkWindowSize();
    window.addEventListener('resize', checkWindowSize);
    return () => window.removeEventListener('resize', checkWindowSize);
  }, []);

  const handleTabClick = (e, tabId) => {
    onChange(tabId);
    e.target.focus();
  };

  return (
    <div
      className={cn(
        'lds-tab-group',
        {
          'lds-card': tabStyle === 'card',
          'full-width': tabStyle !== 'card',
        },
        className
      )}
      id={id}
      aria-label={ariaLabel}
      role="application"
      {...rest}
    >
      <div
        className={cn(
          'lds-tab-header',
          {
            [tabAlign]: tabAlign,
          }
        )}
      >
        <DesktopTabButtons
          activeTab={activeTab}
          tabStyle={tabStyle}
          handleTabClick={handleTabClick}
          tabLabels={tabLabels}
          forceMobile={forceMobile}
        />
        <MobileTabButtons
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          tabLabels={tabLabels}
          groupId={id}
          forceMobile={forceMobile}
        />
      </div>
      <div
        tabIndex={0}
        className={cn(
          'lds-tab-container',
          {
            'tab-padded': tabStyle === 'card',
            wrapper: tabStyle !== 'card',
          }
        )}
      >
        {children}
      </div>
    </div>
  );
}

LdsTabs.propTypes = {
  id: PropTypes.string.isRequired,
  activeTab: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func.isRequired,
  tabLabels: PropTypes.array.isRequired,
};
